import { Theme } from '@mui/material';

/**
 * Styling for TableActionMenuPlugin
 * @returns TableActionMenuPlugin CSS properties as a JSON object
 * @param theme - theme from mui
 * @example ccfTableActionMenuPluginStyles(theme)
*/
const ccfTableActionMenuPluginStyles = (theme: Theme) => {
  const styles = {
    dropdown: {
      zIndex: '10',
      display: 'block',
      position: 'absolute',
      boxShadow: '0 0.75rem 1.75rem 0 rgba(0, 0, 0, 0.2), 0 0.125rem 0.25rem 0 rgba(0, 0, 0, 0.1), inset 0 0 0 0.06rem rgba(255, 255, 255, 0.5)',
      borderRadius: '0.25rem',
      maxHeight: '9.375rem',
      overflowY: 'auto',
      backgroundColor: theme?.palette?.text?.white,
      '&::-webkit-scrollbar': {
        width: '0.25rem',
        height: '0.25rem',
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: theme?.palette?.background?.scrollTrack,
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: theme?.palette?.background?.scrollThumb,
        borderRadius: '1.875rem',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        backgroundColor: theme?.palette?.background?.scrollThumbHover,
      },
    },
    item: {
      margin: '0 0.5rem 0 0.5rem',
      padding:'0.5rem',
      color: theme?.palette?.text?.charcolGrey,
      cursor: 'pointer',
      lineHeight: '0.75rem',
      fontSize: '0.75rem',
      fontWeight: '600',
      display: 'flex',
      alignContent: 'center',
      flexDirection: 'row',
      flexShrink: '0',
      justifyContent: 'space-between',
      backgroundColor: theme?.palette?.text?.white,
      borderRadius: '0.25rem',
      border:'0',
      maxWidth: '15.62rem',
      minWidth: '6.25rem',
      '&:hover':{
        backgroundColor: theme?.palette?.background?.LogoColor,
      },
      '&:first-child':{
        marginTop: '0.5rem',
      },
      '&:last-child':{
        marginBottom: '0.5rem',
      },
      
    },
    text: {
      display: 'flex',
      lineHeight: '0.625rem', 
      flexGrow: '1',
      minWidth: '9.375rem',
    },
    tableCellActionButtonContainer:{
      position: 'absolute',
      top: '0',
      left: '0',
      willChange: 'transform',
    },
    tableCellActionButton: {
      justifyContent: 'center',
      alignItems: 'center',
      border: '0',
      position: 'relative',
      borderRadius: '0.937rem',
      color: theme?.palette?.background?.LogoColor,
      display: 'inline-block',
      backgroundColor: theme?.palette?.text?.main,
      cursor: 'pointer',
      height:'1.25rem',
    },
    modalContainer: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: 'background.paper',
      border: `0.063rem solid ${theme?.palette?.border?.dark}`,
      borderRadius: '0.313rem', 
      boxShadow: '24',
      padding: '1.5rem',
      width: '26.25rem',
      fontSize: '0.813rem', 
      [theme.breakpoints.down(500)]: {
        width: '21.25rem',
        fontSize: theme?.typography?.h6?.fontSize,
      },
    },
    ColorPickerPopover: {
      backgroundColor: `${theme?.palette?.background?.paper}`,
      width: '7.5rem',
      border: `1px solid ${theme?.palette?.border?.dark}`,
    },
    ColorButton: {
      width: '1.125rem',
      height: '1.125rem',
      border: `1px solid ${theme?.palette?.background?.toolTipBg}`,
      borderRadius: '3px',
      margin: '2px',
      cursor: 'pointer',
    },
    ColorButtonContainer: {
      display: 'grid',
      gridTemplateColumns: 'repeat(4, 1fr)',
      justifyItems: 'center',
      padding: '0.3rem',
      borderTop: `1px solid ${theme?.palette?.border?.dark}`,
    },
    ColorResetButton: {
      padding: '0.3rem 0',
      cursor: 'pointer',
      fontSize: '0.75rem',
      width: '100%',
    },
  }
  return styles;
}

export default ccfTableActionMenuPluginStyles;